import React from 'react';
import BasicModal from "components/common/BasicModal";


export default class ConfirmationModal extends React.Component {
    
    render() {
      return (
        <BasicModal
          header="Are you sure?"
          specialType="primary-modal db-create-break-modal fadeInUp animResponse"
          dimmer='inverted'
          modalSize="small"
          actions={[
            {
              label: "No",
              action: this.props.handleClose,
              displayType: "button",
            },
            {
              label: "Yes - approve!",
              action: this.props.handleConfirm,
              displayType: "button",
              primaryCheck: true
            }
          ]}
          open={this.props.modalOpen}
          onClose={this.props.handleClose}>
              <p>
              Are you sure you want to approve this entry?

              </p>

        </BasicModal>
      );
    }
  };
  


// WEBPACK FOOTER //
// ./public/pages/UGCModeration/ConfirmationModal.jsx